import { gql } from '@apollo/client';

export const DCR_FIELDS_FRAGMENT = gql`
    fragment DCRFields on DCR {
        pk
        sk
        dcrId
        siteId
        patientId
        studyInstanceId
        studyActivityInstanceId
        studyEventRef
        studyActivityRef
        type
        subType
        status
        critical
        assignedTo
        siteIdentifier
        eventName
        activityName
        rejectionReviewed
        selfEvidentCorrection
        taskId
        site {
            data
        }
        reason {
            field
            reasonId
            reasonText
        }
        patient {
            screeningIdentifier
            prescreeningIdentifier
            randomizationIdentifier
        }
        clarifiedException {
            clarifiedBy
            clarifiedByName {
                firstName
                lastName
            }
            clarifiedByRole
            clarifiedDescription
            clarifiedType
            deviation
        }
        workflow {
            step
            status
            type
            data {
                roles
                createdAt
                createdBy
                updatedAt
                updatedBy
                updatedByRoleId
                createdByName {
                    firstName
                    lastName
                }
                updatedByName {
                    firstName
                    lastName
                }
                rejectionReason
            }
        }
        comment
        createdByName {
            firstName
            lastName
        }
        updatedBy
        createdAt
        createdByRole
        s3Files {
            fileName
            contentType
            s3Key
            fileSize
            thumbnail
            s3KeyP400
        }
    }
`;

export const listDCRs = gql`
    ${DCR_FIELDS_FRAGMENT}
    query listDCRs(
        $filter: SearchableDCRsFilterInput
        $sort: [SearchableCoreDataSortInput]
        $limit: Int
        $nextToken: Int
    ) {
        listDCRs(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
            items {
                ...DCRFields
                inputs {
                    __typename
                    ... on TransferSwapActivityData {
                        sourceAppointmentId
                        destinationAppointmentId
                        destinationStudyInstanceId
                        destinationPatientId
                        destinationPatientScreeningIdentifier
                        destinationAppointmentTitle
                        activityGroupId
                        activityId
                    }
                    ... on ChangeData {
                        inputUpdateSubjectStudyActivityInstance
                        oldSubjectStudyActivityInstance
                        inputSaveEditCheck
                    }

                    ... on PatientSiteTransfer {
                        oldSiteId
                        newSiteId
                    }
                    ... on Exception {
                        description
                    }
                    ... on ChangeVisitDate {
                        appointmentId
                        oldStartAt
                        oldEndAt
                        updatedStartAt
                        updatedEndAt
                        newStartAt
                        newEndAt
                    }
                    ... on ChangeTranscriptionDetails {
                        newReasonForTranscription
                        newDataCollectionStartDate
                        newDataCollectionStartTime
                        newDataCollectionEndDate
                        newDataCollectionEndTime
                        oldReasonForTranscription
                        oldDataCollectionStartDate
                        oldDataCollectionStartTime
                        oldDataCollectionEndDate
                        oldDataCollectionEndTime
                    }
                }
            }
            statusMetrics {
                pendingReviewTotal
                pendingApprovalTotal
                completedTotal
                rejectedTotal
            }
            totalItems
        }
    }
`;

export const GetDCRConfigQuery = gql`
    query GetDCRConfig($input: InputGetDCRConfig!) {
        getDCRConfig(input: $input) {
            pk
            sk
            configVersion
            configStatus
            viewRoles
            dcrTypeConfigs {
                pk
                sk
                selfService
                status
                dcrType
                openRoles
                approveRoles {
                    order
                    roleId
                }
                createdByName {
                    firstName
                    lastName
                }
                updatedByName {
                    firstName
                    lastName
                }
                updatedAt
            }
            dcrEnabled
        }
    }
`;

export const DCR_COUNT_QUERY = gql`
    query getDCRIndicatorCounters($input: InputGetDCRIndicatorCounters!) {
        getDCRIndicatorCounters(input: $input) {
            assignedToMe
            assignedToPatient
        }
    }
`;
